import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { ProfessionalCalendarRequestAccessUrlQuery } from '@gql/graphql';

export const PRO_CALENDAR_REQUEST_ACCESS_URL = graphql(`
  query ProfessionalCalendarRequestAccessUrl {
    professionalCalendarRequestAccessUrl
  }
`);

export const useProCalendarRequestAccessUrl = () => {
  const { data, error, loading } = useQuery<ProfessionalCalendarRequestAccessUrlQuery>(
    PRO_CALENDAR_REQUEST_ACCESS_URL,
  );

  return {
    url: data?.professionalCalendarRequestAccessUrl,
    urlError: error,
    urlLoading: loading,
  };
};
